// extracted by mini-css-extract-plugin
export var list = "partners-list-module--list--+M-Op";